import { cn } from "@/lib/utils";

/**
 * A tinted pill with a hairline, rather than a solid fill.
 *
 * A saturated block of colour fights the gold on a dark ground and reads as a
 * warning wherever it lands; a 15% wash behind the same hue says the same
 * thing quietly. Named StatusPill rather than Badge so it does not collide
 * with the vendored shadcn `Badge`, which is still used for neutral labels.
 */
const TONES = {
  success: "bg-success/15 text-success border border-success/40",
  warning: "bg-warning/15 text-warning border border-warning/40",
  info: "bg-info/15 text-info border border-info/40",
  destructive:
    "bg-destructive/15 text-destructive border border-destructive/40",
  muted: "bg-muted text-muted-foreground border border-border",
  accent: "bg-primary/15 text-primary",
} as const;

export type StatusTone = keyof typeof TONES;

export function StatusPill({
  tone = "muted",
  icon: Icon,
  children,
  className,
}: {
  tone?: StatusTone;
  icon?: React.ElementType;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium",
        TONES[tone],
        className,
      )}
    >
      {Icon && <Icon className="h-3 w-3" />}
      {children}
    </span>
  );
}
